import { render, staticRenderFns } from "./BidViewModal.vue?vue&type=template&id=fba0cf68&scoped=true&"
import script from "./BidViewModal.vue?vue&type=script&lang=js&"
export * from "./BidViewModal.vue?vue&type=script&lang=js&"
import style0 from "./BidViewModal.vue?vue&type=style&index=0&id=fba0cf68&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba0cf68",
  null
  
)

export default component.exports